import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const redirectToPrivacyPolicy = () => {
        navigate("/privacypolicy");
    };
    return (
        <div dir="ltr" className="w-full py-2 px-5 justify-center flex flex-wrap items-center gap-x-2">
            <span className="text-white">
                © {currentYear}
            </span>
            <span className="primary-text font-bold">
                DODEAL
            </span>
            <span>|</span>
            <span>All Rights Reserved </span>
            <span>|</span>
            <div
                onClick={redirectToPrivacyPolicy}
                className="cursor-pointer hover:underline text-white"
            >
                Privacy Policy
            </div>
        </div>
    );
}

export default Footer;
